"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GeoLine = void 0;
const iotv_v3_types_1 = require("@iotv/iotv-v3-types");
const center_1 = require("@turf/center");
const helpers_1 = require("@turf/helpers");
const conversion_1 = require("../../util/geo/S2/conversion");
const TurfUtils_1 = require("../../util/geo/TurfUtils");
const GeoModelCommon_1 = require("./GeoModelCommon");
const debug = process.env.REACT_APP_DEBUG && false;
const typeName = 'Geofence';
class GeoLine extends GeoModelCommon_1.GeoModelCommon {
    constructor(ob) {
        super({ ...ob, type: ob.type ?? typeName });
        if (!ob.points) {
            debug && console.log('GeoLine assigned empty points', this);
            this.points = [];
        }
        else {
            this.points = ob.points;
        }
        if (this.points.length > 0) {
            if (this.points.length > 2) {
            }
            /** Turf Array has lng before lat */
            const pArray = this.points.filter(({ lat, lng }) => (0, iotv_v3_types_1.isNonNaNNumber)(lat) && (0, iotv_v3_types_1.isNonNaNNumber)(lng)).map(({ lat, lng }) => [lng, lat]);
            const xCenter = (0, center_1.center)((0, helpers_1.points)(pArray)).geometry.coordinates;
            this.location = (0, TurfUtils_1.convertTurfPointsToGLatLng)(xCenter);
            this.dsk = (0, conversion_1.convertLatLngLocationToId)(this.location, this.cellLevel);
            this.bbox = (0, TurfUtils_1.positionArrayToBBox)(this.points);
        }
    }
    getUserAttributes() {
        return {
            ...super.getUserAttributes(),
            points: {
                type: 'object',
            },
        };
    }
}
exports.GeoLine = GeoLine;
